module.exports = __webpack_public_path__ + "img/spring_trip-20160416-12.1598cb8a.jpg";